import { render } from "./AiGradientButton.vue?vue&type=template&id=5bd11ed8&scoped=true&ts=true"
import script from "./AiGradientButton.vue?vue&type=script&lang=ts"
export * from "./AiGradientButton.vue?vue&type=script&lang=ts"

import "./AiGradientButton.vue?vue&type=style&index=0&id=5bd11ed8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd11ed8"]])

export default __exports__